
  $(document).ready(function(){
   //$('body').on('click','.custome_cart_icon', function(){ alert('');
   $('.custome_cart_icon').click(function(){
         	var url=$(this).attr("href");
        	window.location.href=url;
     
    });
    $('.custome_cart_icon').mouseout(function(){  
    	if($('.min_cart').hasClass('active'))
        {
          $('.min_cart').removeClass('active');
        }
    });
    
    
/*  $('.add_to_cart_ajax').click(function(e){  
    $btnclass=$(this);
   
     
    var pid = $(this).attr('data-pid');
    
      jQuery.post('/cart/add.js', {
        quantity: 1,
        id: pid        
      });
    
    setTimeout(function(){ 
 	 
          $.ajax({
                url: '/cart.js',
                dataType: "json",
                cache: false,
                success: function(cart) {
                refreshCart(cart);
                top_shipping_earning(cart);
                window.setTimeout(function() {                 
                  $('#min-cart #min-cart_a').trigger('click');
                   $btnclass.removeClass('pink_bg');
                  
                   $btnclass.children('.adding_txt').animate({ opacity: 0 }, 700);
    			   $btnclass.children('.added_txt').animate({ opacity: 1 }, 900);   
                }, 100);
              }
          });
     backtocart($btnclass);
    },1400); 
        
	    e.preventDefault();
  });
    */


    

  });

function reChargeProcessCart() {
	function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
	do {
      		token=get_cookie('cart');
	}
	while(token == undefined);

	var myshopify_domain='finn-and-emma.myshopify.com'
	try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
	var customer_param = ''
	var checkout_url= "https://checkout.rechargeapps.com/r/checkout?myshopify_domain="+myshopify_domain+"&cart_token="+token+"&"+ga_linker+"&"+customer_param;
    $(location).attr('href', checkout_url);
     
}



function hide_price_button_mobile()
{
  var window_w = $(window).width();
  if(window_w<769){
   // $('.mobile-view-price').css("display", "none");
   // $('.product-form__item.product-form__item--submit button span').css("left", "auto");
  }
}
function show_price_button_mobile()
{
 var window_w = $(window).width();
  if(window_w<769){
   // $('.mobile-view-price').removeAttr("style");
   // $('.product-form__item.product-form__item--submit button span').removeAttr("style");
   }
}
 function backtocart($btnclass)
    {
     
      
         setTimeout(function(){ 
                 $btnclass.children('.addtocart_txt').animate({ opacity: 1 }, 700);
                  $btnclass.children('.added_txt').animate({ opacity: 0 }, 900); 
         },5000);
    }

function top_shipping_earning(cart)
{
  	  						
		
    var free_price = 0;
    
    var total_price =  Shopify.formatMoney(cart.total_price) ; 
    total_price= total_price.replace("$", "");
 
     if(total_price < free_price)
   { 
     
     var  earning_amount =  (parseFloat(free_price) -  parseFloat(total_price))*100;   
     
     if($('p.announcement-bar__message span').hasClass('shipping_header_msg')){
  	 	$('p.announcement-bar__message .shipping_header_msg').html('  '+ Shopify.formatMoney(earning_amount) +'  ');
        }
         else if($('p.announcement-bar__message span').hasClass('show_jquery_price'))
        {
          $('p.announcement-bar__message .show_jquery_price').html('  '+ Shopify.formatMoney(earning_amount) +'  ');
        }
      var window_w = $(window).width();
        if(window_w<769)
        {
          $('.announcement-bar__message .announcement-bar_right').hide();
          $('.announcement-bar__message .shipping_header_msg').show();
        }
                                                               
   }else
    { 
       if($('p.announcement-bar__message span').hasClass('shipping_header_msg')){
  	 	 $('p.announcement-bar__message .shipping_header_msg').html('');     
        } else if($('p.announcement-bar__message span').hasClass('show_jquery_price'))
        {
           $('p.announcement-bar__message .show_jquery_price').html('');     
        }                                                              
                                                                    
                                                         
     }
}

function refreshCart(cart) {
             if(typeof window.BOLD !== 'undefined'
                && typeof window.BOLD.common !== 'undefined'
                && typeof window.BOLD.common.cartDoctor !== 'undefined') {
               // NOTE: "cart" should be the variable containing the cart json data
               cart = window.BOLD.common.cartDoctor.fix(cart);
             }           

    $cartBtn = $(".custome_cart_icon");
    if ($cartBtn) {
        var $cartCount = $cartBtn.find('.mc_footer_box_left');
        var value = $cartCount.text() || '0';
        var cart_items_html = '<div class="min_cart_outer"> <div class="mc_item_box">';
        var $cart = $(".min_cart");
        


        if ( cart.item_count == 0) {
           // $cart.append('<li class="mm-label empty_cart"><a href="/cart">empty_cart</a></li>');
           // $cartCount.remove();
        } else {
            $.each(cart.items, function(index, item) {
               
          
              
                var line_id = index ;
                 var variantTitle = item.title.split('-');
				 var varientname ='';
              		for(var i=0;i<variantTitle.length;i++)
                    {
                      if(i!=0){
                        if((variantTitle.length-1)==i)
                        {
                          varientname += variantTitle[i];
                        }else
                        {
                        	varientname += variantTitle[i]+'-';
                        }
                      }
                    }

                   cart_items_html +=  ' <div class="min_cart_items"> <div class="min_cart_img">';
                console.log(item);
              if(typeof item.image !==  'undefined'){
                   cart_items_html += '<img class="cart__image" src="' + item.image + '" alt="' + item.title + '" />';
                 }             
                  cart_items_html += '</div>	 <div class="min_cart_txt mc_txt_style">   ';
                                 var tit =  variantTitle[0]
                                var arr = tit.split('|');
                                var arr2 = arr[0].split('[');
                   
                   				cart_items_html +=	'<a href="' + item.url + '">'+ arr2[0] + '</a><br/>' ;  
                                var count = arr.length;
              					var v_name='';
              					if(count>0)
                                {
                                  for(var i=0; i<count; i++)
                                  {
                                    if(i !=0)
                                    v_name +=arr[i]+ " ";
                                   
                                  }
                                }else
                                {
                                  var arr1 = tit.remove(']');
                                  arr1 = arr1.split('[');
                                   count = arr1.length;
                                  if(count>0){
                                    for(var i=0; i<count; i++)
                                    {
                                      if(i !=0)
                                      v_name +=arr1[i]+ " ";
                                    }
                                  }
                                    
                                }
                           
                            if(typeof item.properties !==  'undefined'){
                               //cart_items_html += '<div class="cart__meta-text">'+ item.properties.info + '</div>';
                            }
                     		cart_items_html += v_name+' <div class="mc_price">'+ Shopify.formatMoney(item.price, $cart.data('money-format')) +'</div>'+
                     
                                  '<div class="mc-text">';
                              if( varientname != '')
                              {
                                varientname =  varientname.replace('Default /','');
                                cart_items_html += ' <div class="mincart-var">Size:' + varientname +'</div>';
                              }      
                    			 cart_items_html += 	 '<span class="mc_qty">qty: '+item.quantity +'</span>'+
                                    
                                  '</div>  </div> <div class="clearfix"></div></div>   ';
              	
              //  return false;         
            });

          
                cart_items_html +=  '<div class="clearfix"></div>  <div class="mc_footer"> '+  
                           
                               ' <div class="mc_footer_box_left mc_txt_style">';
            cart_items_html +=  cart.item_count ;
          if(cart.item_count == 1){
               cart_items_html += 'Item';
          	}
            else {  
           		cart_items_html += 'Items';
            }
          
           cart_items_html +=  '</div>'+
                                '<div class="mc_footer_box_right mc_txt_style">Total: ' + Shopify.formatMoney(cart.total_price, $cart.data('money-format')) + ' </div>'+
                           	'<div class="clearfix"></div>'+
                         
                          
                          '<div class="mc_btn_box"> <a href="/cart" class="mc_btn_checkout" >checkout</a></div>'+
                          '</div>';
            

			$cart.html('');
            $cart.append(cart_items_html);
           $cart.addClass('active');
      
           
          

        } 
    }
}


